// extracted by mini-css-extract-plugin
export default {"actions":"actions___r3zfwzj","action":"action___r3zfwzj","remove":"remove___r3zfwzj","btn":"btn___r3zfwzj","purge":"purge___r3zfwzj","accept":"accept___r3zfwzj"};